import { ref } from "vue";

import { MyTaskService } from "@/service/MyTaskService";
import { DialogService } from "@/service/DialogService";
import { SoumuDakokuCheckRequest } from "@/types/MyTask";

export function useSoumuCheckUpdate() {

  const isUpdating = ref(false);

  // 総務チェックを一括登録します。
  const updateSoumuChecks = async (params: SoumuDakokuCheckRequest) => {

    isUpdating.value = true;

    const srv = new MyTaskService();
    DialogService.nowloading('更新中...');

    const res = await srv.updateSoumuChecks(params)
    if (res) {
      await DialogService.info({
        text: `登録しました`
      }, true);
      isUpdating.value = false;
      return true
    } else {
      await DialogService.error({
        text: '予期せぬ事態が発生し登録に失敗しました'
      }, true);
      isUpdating.value = false;
      return false
    }
  };

  return {
    isUpdating,
    updateSoumuChecks,
  }
}
